namespace TabAurous.OMS {
    export interface ProductMasterExcelForm {
        FileName: Serenity.ImageUploadEditor;
    }

    export class ProductMasterExcelForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.ProductMasterExcel';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductMasterExcelForm.init)  {
                ProductMasterExcelForm.init = true;

                var s = Serenity;
                var w0 = s.ImageUploadEditor;

                Q.initFormType(ProductMasterExcelForm, [
                    'FileName', w0
                ]);
            }
        }
    }
}
